module.exports = __webpack_public_path__ + "static/media/line-green.6568b135.svg";